export default "__VITE_ASSET__CQx$cEGJ__"